import React from 'react'
import ReactDOM from 'react-dom/client'
// Full site lives in App.tsx; showing a holding page while copy is being reworked.
// import App from './App.tsx'
import Holding from './Holding.tsx'
import './styles/globals.css'

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <Holding />
  </React.StrictMode>,
)